import {
  CreateBackgroundCheckConsentRequestBodySchema,
  type CreateBackgroundCheckConsentResponse,
  CreateBackgroundCheckConsentResponseSchema,
} from "@clipboard-health/contract-backend-main";
import { post } from "@src/appV2/api/api";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib";
import {
  useMutation,
  type UseMutationOptions,
  type UseMutationResult,
} from "@tanstack/react-query";
import { type AxiosError } from "axios";

const getPostBackgroundCheckConsentUrl = (workerId: string) => {
  return `${environmentConfig.REACT_APP_BASE_API_URL}/workers/${workerId}/background-check-consents`;
};

interface CreateBackgroundCheckConsentRequestData {
  workerId: string;
  candidateId: string;
}

export function useCreateBackgroundCheckConsent(
  options: UseMutationOptions<
    CreateBackgroundCheckConsentResponse,
    AxiosError,
    CreateBackgroundCheckConsentRequestData
  > = {}
): UseMutationResult<
  CreateBackgroundCheckConsentResponse,
  AxiosError,
  CreateBackgroundCheckConsentRequestData
> {
  return useMutation({
    mutationFn: async (data: CreateBackgroundCheckConsentRequestData) => {
      const { workerId, candidateId } = data;
      const response = await post({
        url: getPostBackgroundCheckConsentUrl(workerId),
        data: {
          data: {
            type: "background-check-consent",
            attributes: {
              candidateId,
            },
          },
        },
        requestSchema: CreateBackgroundCheckConsentRequestBodySchema,
        responseSchema: CreateBackgroundCheckConsentResponseSchema,
      });
      return response.data;
    },
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.POST_BACKGROUND_CHECK_CONSENT_FAILURE,
    },
    ...options,
  });
}
